<template>
  <chart :chart-options="chartOptions" />
</template>

<script>
import HighchartsFormattingWrapper from './HighchartsFormattingWrapper'

export default {
  name: 'TimeSeriesChart',
  components: {
    chart: HighchartsFormattingWrapper
  },
  props: {
    chartData: { type: Object, default: () => ({}) },
    title: { type: String, default: '' }
  },
  computed: {
    series () {
      return Object.entries(this.chartData)
        .sort((a, b) => a[0] - b[0])
        .reduce((s, [timestamp, value]) => {
          s[0].data.push({ x: parseInt(timestamp), y: value })
          return s
        }, [{ name: this.$t('Data', 'Data'), data: [] }])
    },
    chartOptions () {
      return {
        yAxis: {
          min: 0,
          title: {
            text: this.title
          },
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: 'bold'
            }
          }
        },
        series: this.series
      }
    }
  }
}
</script>
